import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "集团", -1)
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-question",
  style: {"padding":"0 10px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_col, { span: 24 }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_col, { span: 24 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          model: _ctx.formInline,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "手机号码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formInline.phone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formInline.phone) = $event)),
                  placeholder: "手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_col, { span: 24 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.AHUsers,
          border: "",
          style: {"width":"100%"},
          stripe: "",
          height: "20vh"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "userphone",
              label: "号码"
            }),
            _createVNode(_component_el_table_column, {
              prop: "packagesName",
              label: "套餐"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.packagesName), 1),
                _createVNode(_component_el_tooltip, {
                  class: "item",
                  effect: "dark",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _ctx.NMProduct(scope.row.productId)
                    }, null, 8, _hoisted_2)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.UserStatus(scope.row.Status)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "orderStatus",
              label: "电信状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.UserOrderStatus(scope.row.orderStatus)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "regeditTime",
              label: "开通时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "unsubscribeTime",
              label: "取消时间"
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (_ctx.unsubscribe(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "text",
                  onClick: ($event: any) => (_ctx.GetUserOrderLog(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查看详情")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "查看用户信息",
      modelValue: _ctx.UserOrderLog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.UserOrderLog) = $event)),
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          ref: "table",
          data: _ctx.UserOrderLogList,
          border: "",
          style: {"width":"100%"},
          height: "40vh",
          "row-key": "complaintFormId",
          stripe: "",
          "header-cell-style": {'text-align':'center'},
          "cell-style": {'text-align':'center'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userphone",
              label: "用户号码"
            }),
            _createVNode(_component_el_table_column, {
              prop: "operate",
              label: "所做操作"
            }),
            _createVNode(_component_el_table_column, {
              prop: "instruct",
              label: "操作内容"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "操作时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "memo",
              label: "备注"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}